/*
 * @Author: your name
 * @Date: 2021-11-02 09:24:14
 * @LastEditTime: 2021-11-05 15:12:03
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \System11.02\src\utils\request.js
 */
/****   request.js   ****/
// 导入axios  接口封装统一管理
import axios from 'axios'
// 使用element-ui Message做消息提醒
import { ElMessage as Message } from 'element-plus'

//1. 创建新的axios实例，
const service = axios.create({
  // 公共接口
  baseURL: process.env.BASE_API,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 3600 * 1000
})

// http request拦截器 添加一个请求拦截器
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  // let token = 'ce1114e5-ef36-4717-abc5-1bfe59080500';
  if (window.localStorage.getItem("token")) {
    let token = window.localStorage.getItem("token");
    // let token = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6IjQ5ZmMzZTExLTQ2MWUtNGJmMS1iNzZmLTI0Mzk1NDczM2I1NiJ9.Fk-blKBMbu56uFdoqVMXpmf1YRYyD7Y16VmxjNICuwor69DRUosiZtAcRtmlBL2Y3hNvt2LiETaXEneCwbyFGQ'
    config.headers.Authorization = token;    //将token放到请求头发送给服务器
    //这里经常搭配token使用，将token值配置到tokenkey中，将tokenkey放在请求头中
    // config.headers['accessTokenFuXin'] = Token;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// 2.请求拦截器
service.interceptors.response.use(response => {
  if(response.headers.authorization) {
    window.localStorage.removeItem("token");
    localStorage.setItem('token', response.headers.authorization);
  }
  let data=response.data
  // 根据返回的code值来做不同的处理(和后端约定)
  switch (data.code) {
    // 错误
    case 401:
      Message({
        showClose: false,
        message: '未登录',
        type: 'error',
        duration: 1000
      })
      window.location.href = '/#/login'
      break;
    case 404:
      Message({
        showClose: false,
        message: '接口错误',
        type: 'error',
        duration: 1000
      })
      break;
    case 500:
      Message({
        showClose: false,
        message: data.msg,
        type: 'error',
        duration: 1000
      })
      break;
      case 9:
        Message({
          showClose: false,
          message: data.msg,
          type: 'error',
          duration: 1000
        })
        break;
    case 0:
      return data;
      break
    default:
      return data;
  }
  return data;
}, (err) => {
  // 返回状态码不为200时候的错误处理
  console.log(err)
  console.log('连接错误，请重试');
  return Promise.resolve(err);
});


//4.导入文件
export default service